import React from'react';
import {Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useHistory} from "react-router-dom"
import {connect} from 'react-redux';
import * as actionTypes from '../../../redux/constants';

const SSOModal = (props) => {

    const {t} = useTranslation();

    let history = useHistory();

    const logoutUser = () => {
        props.clearUserData();
        props.clearSSOModal();
        history.push('/');
    };

    return (
        <Dialog
            open={props.showSSOLogoutModal}
        >
            <DialogTitle id={'error-dialog'} color={'primary'}>{t('Global.sso_warning')}</DialogTitle>
            <DialogContent>
                <Typography control={'p'} variant={'body1'} color={'validation'}>
                    {t('Global.sso_title')}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    color={'secondary'}
                    variant={'contained'}
                    onClick={() => {
                        logoutUser();
                    }}
                >
                    {t('Global.session_logout')}
                </Button>

            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = (state) => {
    return {
        showSSOLogoutModal: state.uxStateReducer.get("showSSOLogoutModal")
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearUserData: () => dispatch({
            type: actionTypes.CLEAR_CURRENT_USER_DATA
        }),
        clearSSOModal: () => dispatch({
            type: actionTypes.HIDE_SSO_MODAL
        })
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SSOModal);